// import { ReactElement } from "react";
import Header from "@layouts/Main/lib/Header";
import Footer from "@layouts/Footer";
import PageInterest from "@containers/InterestForm";
import Layout from "@pwa/layout";
import { NextPage, NextPageContext } from "next";
import { canonicalLink } from "@helpers/url";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { localeKey } from "@constants/locale-key";
import useResponsive from "@helpers/useResponsive";
import { isAllowInterest } from "@config/feature";

const PageInterestForm: NextPage<any> = ({ dataNavbar }) => {
  const isMobile = useResponsive("sm", true);

  if (isMobile) {
    return (
      <Layout layoutType="noPaddingX" page={"subscribed"}>
        <PageInterest />
      </Layout>
    );
  }

  return (
    <>
      <Header
        setExpand={function (): void {
          throw new Error("Function not implemented.");
        }}
        withoutNavigation
      />
      <PageInterest />
      <Footer dataNavbar={dataNavbar} />
    </>
  );
};

export async function getServerSideProps({ locale }: NextPageContext) {
  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, locale ?? "id");

  return {
    notFound: !isAllowInterest,
    props: {
      ...(await serverSideTranslations(locale ?? "id", localeKey)),
      title: "Interested Form",
      description:
        "MyTEnS by Telkom Indonesia can help improve and incredibly transform your business with our integrated solutions and reliable experts.",
      imageUrl: "",
      canonical: canonicalLink("/interest-form", locale),
      dataNavbar: dataProductMenu,
    },
  };
}

export default PageInterestForm;
